import { Box, Pagination, Table, Typography } from "@mui/material";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

import Colors from "@constants/Colors";
import styled from "styled-components";
import { Link } from "react-router-dom";

export const StyledBox = styled(Box)`
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  gap: 8px !important;
  overflow-x: scroll;
`;

export const StyledBodyTableCell = styled(TableCell)`
  padding: 10px 12px 9px !important;
  font-family: "Ringside Regular-Book" !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 20px !important;
`;

export const StyledTable = styled(Table)`
  border-radius: 12px !important;
  border: 1px solid ${Colors.neutral_gray_300} !important;
  box-shadow: ${Colors.Elevation_2} !important;
  border-radius: 4px !important;
`;

export const StyledButtonBox = styled(Box)<{
  pagination: boolean | undefined | string;
}>`
  display: flex !important;
  flex-direction: column !important;
  align-items: ${({
    pagination,
  }: {
    pagination: boolean | undefined | string;
  }) => (pagination ? "center" : "flex-end")} !important;
  padding: 0px !important;
`;

export const StyledPagination = styled(Pagination)`
  font-family: "Ringside Regular" !important;
  font-weight: 400 !important;
  font-size: 16px !important;
  line-height: 24px !important;
  .Mui-selected {
    color: ${Colors.primary} !important;
    background-color: ${Colors.neutral_gray_100} !important;
    border: 1.5px solid ${Colors.primary} !important;
  }
`;

export const StyledTableRow = styled(TableRow)`
  height: 40px !important;
`;

export const StyledLink = styled(Link)`
  font-family: "Ringside Regular-Bold" !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 20px !important;
  min-width: 60px;
  text-decoration: none;
  color: ${Colors.primary};
`;

export const AlertTypography = styled(Typography)`
  color: ${Colors.error_600};
  font-family: "Ringside Regular-Book" !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 20px !important;
`;

export const StyledTypography = styled(Typography)`
  font-family: "Ringside Regular-Book" !important;
  padding-left: 24px !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 20px !important;
`;

export const StyledCellBox = styled(Box)`
  display: flex !important;
  align-items: center !important;
  gap: 8px;
`;
